<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'student/index' }">
                                Siswa
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'student/candidate/index' }">
                                List Calon Siswa
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ student.user.name }}
                        </li>
                    </ul>
                </nav>
            </div>
	    <div class="col-auto mt-4 mb-2"  >
                <button v-b-tooltip.hover title="Download Kuitansi Formulir Siswa" v-on:click="downloadKuiform" type="button" class="btn btn-sm btn-danger px-3">
                    Download Kuitansi Formulir
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-12">
		<form v-on:submit.prevent="save" disabled>
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Data Kepesertaan Siswa BTA
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                    </div>
                                    <div class="input-action">
                                        <button type="submit" class="btn btn-danger btn-sm btn-outline-white h4 my-0 mr-2">
                                            Save
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm btn-outline-white h4 my-0" v-on:click="toggleInput">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                    </div>
                    <div class="card-body">
                        <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tahun Ajaran</label>
                                </div>
                                <!--<div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-bind:value="student.term.name" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm" />
                                </div>-->
				<div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <select v-model="form.student.termID" class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled required>
                                        <option disabled value="">Pilih Tahun Ajaran...</option>
                                        <option v-for="term in terms" v-bind:value="term.id" v-bind:key="term.id">{{ term.name }}</option>
                                    </select>
				    <!-- <input v-else class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="student.term.name" /> -->
                                </div>
				
				
                            </div>
			<div class="row mb-1 align-items-center" v-for="attribute in ['nomor_formulir']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nomor Formulir</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                            </div>
                        </div>
			<div class="row mb-1 align-items-center" v-for="attribute in ['IUP_nomor']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nama Petugas Formulir</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                            </div>
                        </div>
			<div class="row mb-1 align-items-center" v-for="attribute in ['IUP_prodi']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Metode Pembayaran Formulir</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="Tunai/Transfer Via Bank" />
                            </div>
                        </div>
			<div class="row mb-1 align-items-center" v-for="attribute in ['TS_nomor']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Kode Transfer</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                            </div>
                        </div>
			<div class="row mb-1 align-items-center" v-for="attribute in ['PPKB_univ']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Cetak Kuitansi</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" placeholder="15 AGUSTUS 2020" />
                            </div>
                        </div>	
			<div class="row mb-1 align-items-center" v-for="attribute in ['PPKB_prodi']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nama Rekening Pengirim</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm"  />
                            </div>
                        </div>
			<div class="row mb-1 align-items-center" v-for="attribute in ['Mandiri_3_nomor']">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nomor Referensi</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <input v-model="form.profile[attribute]" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm"  />
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Tanggal Daftar</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <template v-if="student.registeredAt">
                                    <h4 class="font-weight-medium mb-0 py-1">
                                        {{ $moment(student.registeredAt, 'YYYY-MM-DD').format('D MMMM YYYY') }}
                                    </h4>
                                </template>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Cabang</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <h4 class="font-weight-medium mb-0 py-1">
                                    {{ student.branch.name }}
                                </h4>
                            </div>
                        </div>
			<div class="row mb-1 align-items-center" v-for="attribute in [ 'pembelajaran']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.additionals[attribute] }}
                                        </h4>
                                    </div>
                        </div>
			<div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Rencana Pola Hari</label>
                                </div>
                             	<h4 class="font-weight-medium mb-0 py-1">
                                    {{ student.studentVerified.paymentNote }}
                                </h4>
				<!--<div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.verified.paymentNote" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>-->
                        </div>
			<div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">Rencana Pilihan Pembayaran</label>
                                </div>
                                <h4 class="font-weight-medium mb-0 py-1">
                                    {{ student.studentVerified.payment }}
                                </h4>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Ukuran Jaket Khusus Kelas 12 & Alumni</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <h4 class="font-weight-medium mb-0 py-1">
                                    {{ student.additionals.ukuran_jaket }}
                                </h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center" v-for="n in 3">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Sekolah/ Universitas Impian {{ n }}</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <h4 class="font-weight-medium mb-0 py-1">
                                    {{ student.additionals['sekolah_impian_' + n] }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
		</form>
            </div>
            <div class="col-md-4 col-sm-12" v-if="student.product">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Produk
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <img v-bind:src="student.product.imageUrl" class="w-100 img-fluid mb-3" />
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Nama</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <h4 class="font-weight-medium mb-0 py-1">{{ student.product.name }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Harga</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <h4 class="font-weight-medium mb-0 py-1">{{ student.product.price | currency }}</h4>
                            </div>
                        </div>
                        <div class="row mb-1 align-items-center">
                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                <label class="font-weight-medium text-muted h4 mb-0 form-divider">Deskripsi</label>
                            </div>
                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                <h4 class="font-weight-medium mb-0 py-1">{{ student.product.description }}</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <!-- Section 1 -->
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Profil Siswa
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nama Lengkap</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.user.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Alamat Email</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.user.email }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Asal Sekolah</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.school.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi Sekolah</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.grade.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Prodi BTA</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.btaGrade.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center" v-for="attribute in ['tempat_lahir']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.additionals[attribute] }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1" v-if="student.additionals.tanggal_lahir">
                                            {{ $moment(student.additionals.tanggal_lahir, 'YYYY-MM-DD').format('D MMMM YYYY') }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center" v-for="attribute in ['jenis_kelamin', 'alamat_rumah', 'kode_pos', 'nomor_telp_rumah', 'nomor_hp_siswa']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.additionals[attribute] }}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <!-- Section 2 -->
                        <div class="card shadow-sm mb-4 border-0">
                            <div class="card-header background-primary">
                                <div class="row justify-content-end">
                                    <div class="col">
                                        <span class="h4 font-weight-medium text-white mb-0">
                                            Data Orang Tua Siswa
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row mb-1 align-items-center" v-for="attribute in ['nama_ayah', 'nomor_hp_ayah', 'email_ayah', 'pekerjaan_ayah', 'nama_ibu', 'nomor_hp_ibu', 'email_ibu', 'pekerjaan_ibu']">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ student.additionals[attribute] }}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Multiselect from 'vue-multiselect';
    import Datepicker from 'vuejs-datepicker';
    import FileIcon from "@/components/item/FileIcon";
    import qs from 'qs';
    import { id } from 'vuejs-datepicker/dist/locale';
    import { semesters } from '@/params.js';

    export default {
        name: "StudentCandidateView",
        components: {
            FileIcon,
	    Multiselect,
            Datepicker
        },
        computed: mapState([
            'profile'
        ]),
	watch: {
            profile() {
                this.fetchBranches();
            },
            'form.student.branchID'(branchID) {
                if (branchID) {
                    this.axios.get(process.env.API_URL + '/branch-program', {params: {branchID: branchID}}).then(response => {
                        this.branchPrograms = response.data.data;

                        if (!(this.branchPrograms.find(branchProgram => branchProgram.id === this.branchProgramID))) {
                            this.branchProgramID = '';
                        }
                    });
                } else {
                    this.branchPrograms = [];
                    this.branchProgramID = '';
                }
            },
            branchProgramID(branchProgramID) {
                if (branchProgramID) {
                    this.axios.all([
                        this.axios.get(process.env.API_URL + '/pattern', {params: {branchProgramID: branchProgramID}}),
                        this.axios.get(process.env.API_URL + '/intensive-schedule', {params: {branchProgramID: branchProgramID}})
                    ]).then(this.axios.spread(function (responsePattern, responseIntensive) {
                        this.patterns = responsePattern.data.data;
                        this.intensives = responseIntensive.data.data;

                        if (!(this.patterns.find(pattern => pattern.id === this.form.verified.patternID))) {
                            this.form.verified.patternID = '';
                        }
                        if (!(this.intensives.find(intensive => intensive.id === this.form.verified.intensiveScheduleID))) {
                            this.form.verified.intensiveScheduleID = '';
                        }
                        if (!(this.intensiveClasses.find(intensiveClass => intensiveClass.id === this.form.verified.intensiveClassID))) {
                            this.form.verified.intensiveClassID = '';
                        }
                    }.bind(this)));
                } else {
                    this.patterns = [];
                    this.intensives = [];
                    this.form.verified.patternID = '';
                    this.form.verified.intensiveScheduleID = '';
                    this.form.verified.intensiveClassID = '';
                }
            },
            'form.verified.patternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.branchClasses = response.data.data;

                        if (!(this.branchClasses.find(branchClass => branchClass.id === this.form.verified.branchClassID))) {
                            this.form.verified.branchClassID = '';
                        }
                    });
                } else {
                    this.branchClasses = [];
                    this.form.verified.branchClassID = '';
                }
            },
            'form.verified.secondPatternID'(patternID) {
                if (patternID) {
                    this.axios.get(process.env.API_URL + '/branch-class', {params: {patternID: patternID}}).then(response => {
                        this.secondBranchClasses = response.data.data;

                        if (!(this.secondBranchClasses.find(branchClass => branchClass.id === this.form.verified.secondBranchClassID))) {
                            this.form.verified.secondBranchClassID = '';
                        }
                    });
                } else {
                    this.secondBranchClasses = [];
                    this.form.verified.secondBranchClassID = '';
                }
            },
            'form.verified.intensiveScheduleID'(intensiveScheduleID) {
                if (intensiveScheduleID) {
                    this.axios.get(process.env.API_URL + '/intensive-class', {params: {intensiveScheduleID: intensiveScheduleID}}).then(response => {
                        this.intensiveClasses = response.data.data;

                        if (!(this.intensiveClasses.find(intensiveClass => intensiveClass.id === this.form.verified.intensiveClassID))) {
                            this.form.verified.intensiveClassID = '';
                        }
                    });
                } else {
                    this.intensiveClasses = [];
                    this.form.verified.intensiveClassID = '';
                }
            }
        },
        data() {
            return {
                form: {
                    student: {
                        username: '', name: '', identity: '', gradeID: '', btaGradeID: '', branchID: '', schoolID: '', email: '', image: ''
                    },
                    profile: {
                        nomor_formulir: '', tempat_lahir: '', tanggal_lahir: '', jenis_kelamin: 'Laki-laki', alamat_rumah: '', kode_pos: '', nomor_telp_rumah: '', nomor_hp_siswa: '',
                        nama_ayah: '', nomor_hp_ayah: '', pekerjaan_ayah: '', email_ayah: '', nama_ibu: '', nomor_hp_ibu: '', pekerjaan_ibu: '', email_ibu: '',
                        ukuran_jaket: '', diterima_jalur: '', diterima_univ: '', diterima_prodi: '',
                        SNMPTN_nomor: '', SNMPTN_univ_1: '', SNMPTN_prodi_1: '', SNMPTN_univ_2: '', SNMPTN_prodi_2: '', SNMPTN_univ_3: '', SNMPTN_prodi_3: '',
                        PPKB_nomor: '', PPKB_univ: '', PPKB_prodi: '',
                        TS_nomor: '', TS_univ: '', TS_prodi: '',
                        IUP_nomor: '', IUP_prodi: '',
                        SIMAK_nomor: '', SIMAK_prodi_1: '', SIMAK_prodi_2: '', SIMAK_prodi_3: '', SIMAK_prodi_4: '', SIMAK_prodi_5: '', SIMAK_prodi_6: '', SIMAK_prodi_7: '',
                        Mandiri_1_nomor: '', Mandiri_1_univ: '', Mandiri_1_prodi: '', Mandiri_2_nomor: '', Mandiri_2_univ: '', Mandiri_2_prodi: '', Mandiri_3_nomor: '', Mandiri_3_univ: '', Mandiri_3_prodi: '',
                        pembelajaran: '', sekolah_impian_1: '', sekolah_impian_2: '', sekolah_impian_3: ''
                    },
                    verified: {
                        patternID: '', branchClassID: '', secondPatternID: '', secondBranchClassID: '', payment: '', paymentNote: '', placement: '', intensiveScheduleID: '', intensiveClassID: ''
                    }
                },
                student: {additionals: {}, branch: {}, user: {}, term: {}},
                modal: false,
                school: null,
                branchProgramID: '',
                branches: [],
                patterns: [],
		terms: [],
                intensives: [],
                branchPrograms: [],
                grades: [],
                branchClasses: [],
                secondBranchClasses: [],
                intensiveClasses: [],
                schools: [],
                imagePreview: '',
                dateLanguage: id,
                semesters: semesters
            };
        },
        methods: {
            save(event) {
                var formData = new FormData();
                for (var group in this.form) {
                    for (var attribute in this.form[group]) {
                        var value = this.form[group][attribute];
                        if (value instanceof Date) {
                            formData.set(group + '[' + attribute + ']', this.$moment(value).format('YYYY-MM-DD'));
                        } else {
                            formData.set(group + '[' + attribute + ']', value);
                        }
                    }
                }
                this.axios.post(process.env.API_URL + '/student/update/' + this.student.userID, formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            removeStudent() {
                this.axios.post(process.env.API_URL + '/student/delete/' + this.student.userID).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'student/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                    this.modal.remove.student = false;
                });
            },
            removeFile() {
                if (this.student.psychoScore) {
                    this.axios.post(process.env.API_URL + '/psycho-score/delete-file/' + this.student.psychoScore.id).then(response => {
                        if (response.data.status) {
                            this.fetchStudent();
                            this.$toastr('success', response.data.message, 'Success');
                        } else {
                            this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                        }
                        this.modal.remove.file = false;
                    });
                }
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.student.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            },
            downloadFile() {
                if (this.student.psychoScore) {
                    let token = localStorage.getItem("vue-authenticate.vueauth_token");
                    window.location = process.env.API_URL + '/psycho-score/download-file/' + this.student.psychoScore.id + '?' + qs.stringify({token: token}, {encode: false});
                }
            },
            downloadKuiform() {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/kuiform/' + this.student.userID + '?' + qs.stringify({token: token}, {encode: false});
            },
            fetchBranches() {
                if (this.profile.isAdmin) {
                    this.axios.get(process.env.API_URL + '/branch').then(response => {
                        this.branches = response.data.data;
                    });
                } else if (this.profile.isEmployee) {
                    if (this.profile.employee.isBranchStaff) {
                        this.form.student.branchID = this.profile.employee.branchStaff.branchID;
                    }
                }
            },
            patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            downloadUTBK(index) {
                let token = localStorage.getItem("vue-authenticate.vueauth_token");
                window.location = process.env.API_URL + '/student/download-utbk?' + qs.stringify({index: index, studentID: this.student.userID, token: token}, {encode: false});
            },
            fileExtension(filename) {
                return filename.split('.').pop() || '';
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.fetchStudent();
                    }
                } else {
                    this.fetchStudent();
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            fetchStudent() {
                this.axios.get(process.env.API_URL + '/student/' + this.$route.params.id).then(response => {
                    this.student = response.data.data;

                    this.school = this.student.school;
                    this.imagePreview = this.student.imageUrl;

                    for (var key in this.student) {
                        if (typeof this.student[key] !== 'object') {
                            this.form.student[key] = this.student[key];
                        }
                    }
                    this.form.student = Object.assign(this.form.student, {
                        name: this.student.user.name,
                        username: this.student.user.username,
                        email: this.student.user.email ? this.student.user.email : '',
                        image: ''
                    });
                    this.form.profile = this.student.additionals;

                    if (this.form.profile.tanggal_lahir) {
                        var moment = this.$moment(this.student.additionals.tanggal_lahir, "YYYY-MM-DD");
                        if (moment.isValid()) {
                            this.form.profile.tanggal_lahir = moment.toDate();
                        }
                    }

                    if (this.student.studentVerified) {
                        if (this.student.studentVerified.pattern) {
                            this.branchProgramID = this.student.studentVerified.pattern.branchProgramID;
                        }
                        if (!this.branchProgramID && this.student.studentVerified.intensiveSchedule) {
                            this.branchProgramID = this.student.studentVerified.intensiveSchedule.branchProgramID;
                        }
                        for (var key in this.student.studentVerified) {
                            if (typeof this.student.studentVerified[key] !== 'object') {
                                this.form.verified[key] = this.student.studentVerified[key];
                            }
                        }
                    }

                    document.title = this.student.user.name + ' - ' + process.env.APP_NAME;
                });
            },
            roleElligibleModified() {
                return this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee.isBranchStaff);
            },
            roleElligibleView() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isBranchStaff || this.profile.employee.isBranchHead));
            }
        },
        created() {
            this.fetchBranches();

            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade'),
		this.axios.get(process.env.API_URL + '/term'),
                this.axios.get(process.env.API_URL + '/school')
            ]).then(this.axios.spread(function (responseGrade, responseTerm, responseSchool) {
                this.grades = responseGrade.data.data;
		this.terms = responseTerm.data.data;
                this.schools = responseSchool.data.data;
            }.bind(this)));

            this.fetchStudent();
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{ display: none; }
    .btn.btn-outline-white { border-color: #fff; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

    form[disabled] select.form-control-plaintext { -moz-appearance: none; -webkit-appearance: none; appearance: none; }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }

</style>


// WEBPACK FOOTER //
// src/components/student/candidate/View.vue